import script from "./BooksDone.vue?vue&type=script&setup=true&lang=ts"
export * from "./BooksDone.vue?vue&type=script&setup=true&lang=ts"

import "./BooksDone.vue?vue&type=style&index=0&id=7c3bbe70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3bbe70"]])

export default __exports__